import React from 'react';
import { stringToNumber } from '../../../../helpers/numberFormatter';

import { useCustomTranslation } from '../../../../hooks/custom-translation';
import { Body, Footnote } from '../../../../styles/fonts';
import Collapse, { Panel } from '../../../Collapse';
import BarChart from '../../../Contacts/Contact/ContactProfile/BarChart';

import {
  Content02,
  CollapseItemContent,
  Data011,
  Question1,
  Label,
} from './styles';

interface FinancialTabProps {
  financialQuestions: { question: string; answer: string }[] | undefined;
}

const Financial = ({ financialQuestions }: FinancialTabProps) => {
  const { tModalPersona } = useCustomTranslation('modalPersona');

  const formatNumber = (num: string | undefined) => {
    if (num !== undefined) {
      return stringToNumber(num);
    }
    return 0;
  };

  return (
    <>
      <Content02>
        <Collapse>
          <Panel header={tModalPersona('financial_behavior')} key="1">
            <CollapseItemContent>
              <Data011>
                {financialQuestions?.map(question => {
                  return (
                    <Question1 key={question.question}>
                      <Body weight="medium">{question.question}</Body>
                      <Label>
                        <Footnote>{tModalPersona('0')}</Footnote>
                        <Footnote>{tModalPersona('10')}</Footnote>
                      </Label>
                      <BarChart
                        value={formatNumber(question.answer) * 10}
                        position="width"
                        backgroundBarColor="#f9f0ff"
                        backgroundBarBorder="#d3adf7"
                        backgroundBarBorderLeft="hidden"
                        pointerBarColor="#d3adf7"
                        pointerBarBorder="#722ed1"
                        pointerBarBorderRadius="0px 8px 8px 0px"
                      />
                    </Question1>
                  );
                })}
              </Data011>
            </CollapseItemContent>
          </Panel>
        </Collapse>
      </Content02>
    </>
  );
};

export default Financial;
